import { createContext, useContext } from "@wordpress/element";
import PropTypes from "prop-types";

export const CartContext = createContext({});
export const useCartContext = () => useContext(CartContext);

export const CartContextProvider = ({ cartLineItems, children }) => {
	const contextValue = {
		cartLineItems,
	};
	return (
		<CartContext.Provider value={contextValue}>{children}</CartContext.Provider>
	);
};

CartContextProvider.propTypes = {
	children: PropTypes.node,
	cartLineItems: PropTypes.arrayOf(PropTypes.object),
};
